module.exports = __webpack_public_path__ + "media/ruoyi_02_摆姿势.593d6bd5.wav";